var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[(this.appVersion)?_c('span',{staticClass:"num-app-version"},[_vm._v("v "+_vm._s(this.appVersion))]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }